import {
  CHANGE_SIDEBAR_VISIBILITY,
  CHANGE_MOBILE_SIDEBAR_VISIBILITY,
  EXPAND_SIDEBAR
} from '../actions/sidebarActions'


let initialState = {
  show: '',
  collapse: ''
}

if(window.screen.width < 1025){
  initialState = {
    show: false,
    collapse: true
  }
}else {
  initialState = {
    show: window.localStorage.getItem('sideBar') ? false : true ,
    collapse: window.localStorage.getItem('sideBar') ? true : false
  }
}


export default function (state = initialState, action) {
// state.show = window.localStorage.getItem('sideBar') ? false :  true;
// state.collapse = window.localStorage.getItem('sideBar') ? true :  false;
  switch (action.type) {
    case CHANGE_SIDEBAR_VISIBILITY:
      return { ...state, show: !state.show , collapse: !state.collapse }
    case CHANGE_MOBILE_SIDEBAR_VISIBILITY:
      return { ...state, show: !state.show , collapse: !state.collapse }
    case EXPAND_SIDEBAR:
      return { ...state, show: !state.show , collapse: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/sidebarReducer.js